import axios from 'axios';

const cricketAPI = axios.create({
    baseURL: '/api/cricket',
    headers: {
        'Content-Type': 'application/json'
    }
});

cricketAPI.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        console.log('📡 Cricket API Request:', config.url);
        return config;
    },
    (error) => Promise.reject(error)
);

cricketAPI.interceptors.response.use(
    (response) => {
        console.log('✅ Cricket API Response:', response.status);
        return response;
    },
    (error) => {
        console.error('❌ Cricket API Error:', error.response?.status || error.message);
        return Promise.reject(error);
    }
);

export const cricketService = {
    getAllMatches: async () => {
        try {
            const response = await cricketAPI.get('/live-matches');
            return response.data;
        } catch (error) {
            console.error('Error fetching matches:', error);
            throw error;
        }
    },

    getLiveMatches: async () => {
        try {
            const response = await cricketAPI.get('/live-only');
            return response.data;
        } catch (error) {
            console.error('Error fetching live matches:', error);
            throw error;
        }
    },

    getStatus: async () => {
        try {
            const response = await cricketAPI.get('/status');
            return response.data;
        } catch (error) {
            console.error('Error checking status:', error);
            throw error;
        }
    }
};

export default cricketService;